
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Decisions, { DecisionsPageProps } from '@screens/Sitemap/Decisions';
import { getYearsDecisionProps } from '@utils/serverSide/decision';
const getServerSideProps = async (): Promise<{
    props: DecisionsPageProps;
}> => {
    const yearsDecisionsProps = await getYearsDecisionProps();
    const years = yearsDecisionsProps?.years ?? [];
    const props: DecisionsPageProps = {
        years,
    };
    return {
        // To avoid SerializableError, wrap props into `JSON.parse(JSON.stringify())`
        // Ex: https://stackoverflow.com/questions/66817759/next-js-error-serializing-res-returned-from-getserversideprops
        props: JSON.parse(JSON.stringify(props)),
    };
};
export default Decisions;

    async function __Next_Translate__getServerSideProps__1a06c87ef2b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sitemap/decisions',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87ef2b__ as getServerSideProps }
  